import { render, staticRenderFns } from "./ItemGroupListEdit.vue?vue&type=template&id=a5a2f39a"
import script from "./ItemGroupListEdit.vue?vue&type=script&lang=js"
export * from "./ItemGroupListEdit.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupListEdit.vue?vue&type=style&index=0&id=a5a2f39a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports